import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import Intiator from "./component/Initiator";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Intiator />);
